import { render, staticRenderFns } from "./Databases.vue?vue&type=template&id=b93c8480&scoped=true&"
import script from "./Databases.vue?vue&type=script&lang=js&"
export * from "./Databases.vue?vue&type=script&lang=js&"
import style0 from "./Databases.vue?vue&type=style&index=0&id=b93c8480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93c8480",
  null
  
)

export default component.exports